import { render, staticRenderFns } from "./BaseTechDescription.vue?vue&type=template&id=272770f1&scoped=true&"
import script from "./BaseTechDescription.vue?vue&type=script&lang=ts&"
export * from "./BaseTechDescription.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTechDescription.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BaseTechDescription.vue?vue&type=style&index=1&id=272770f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272770f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBanner,VCard,VCardText,VCardTitle,VCol,VContainer,VDivider,VRow})
